/**
 * @packageDocumentation
 * @module dom/is
 */

export interface IsNode {
  /**
   * is the node a valid HTML node
   * @param node an unknown object
   * @return true if Node, false otherwise
   */
  (node: unknown): node is Node;
}

/**
 * { @link IsNode }
 */
export default (node: unknown): node is Node =>
  node && typeof node === 'object' && 'nodeType' in node && node['nodeType'] === 1 && !!node['cloneNode'];
